import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
 

function MandatoryContent() {
  const path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const pdfarr = localStorage.getItem('user_id') == "56Ek4feL/1A8mZgIKQWEqg==" ? [3968,3970,4521] : [15118,15119,15120];
  const navigate = useNavigate();
  let data = [
    {
      image: `${path_image}site-user-blinded.svg`,
      title: "Site User-Blinded",
      pdfId : pdfarr?.[0],
    },
    {
      image: `${path_image}investigator-blinded.svg`,
      title: "Investigator-Blinded",
      pdfId : pdfarr?.[2],
    },

    {
      image: `${path_image}blinded-pharmacist.svg`,
      title: "Site Unblinded Pharmacist",
      pdfId : pdfarr?.[1],
    },
        {
      image: `${path_image}site-user-blinded.svg`,
      title: "Radiologist",
      pdfId : pdfarr?.[1],
    },
    {
      image: `${path_image}investigator-blinded.svg`,
      title: "Laboratory",
      pdfId : pdfarr?.[1],
    },

    {
      image: `${path_image}blinded-pharmacist.svg`,
      title: "Monitors",
      pdfId : pdfarr?.[1],
    },
  ];
  let [active, setActive] = useState();

  const handleChange = (value) => {
    setActive(value);
  };

  const navigateToLibraryList = (title,pdfId) => {
    navigate("/library-mandatory-content", { state: { title, flag: "mandatory","mandatoryPdfId" : pdfId  } });
  };
  

  return (
    <>
      <Col className="right-sidebar custom-change">
        <div className="custom-container">
          <Row>
            <div className="top-header sticky">
              <div className="page-title">
                <h2>Mandatory Content</h2>
              </div>
            </div>
            <div className="library_create d-flex library-mandatory">
              {data.map((item, index) => (
                <div
                   key={index}
                  className={
                    active == index
                      ? "col library_create-box active"
                      : "col library_create-box"
                  }
                  onClick={() => navigateToLibraryList(item?.title,item?.pdfId)}
                >
                  <div className="create-library-img">
                    <img src={item.image} alt="Content msg Library" />
                  </div>
                  <div
                    className="create-library-content"
                    
                  >
                    <h3>{item.title == "Site User-Blinded" ? "Blinded Roles" : item.title == "Site Unblinded Pharmacist" ? "Unblinded Roles" : item.title == "Investigator-Blinded" ? "Investigators" : item.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </Row>
        </div>
      </Col>
    </>
  );
}

export default MandatoryContent;
